import axios from 'axios';
import { smallNotification } from '@shared/services/gf.notification.service';

export default {
  setDefaultAvatar(companyAlias) {
    return axios
      .delete(`/api/company/${companyAlias}/avatar`)
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
    setCompanyDefaultCover(companyAlias) {
        return axios
            .delete(`/api/company/${companyAlias}/cover`)
            .then((res) => res.data)
            .catch((err) => {
                throw err;
            });
    },
  setCompanyDefaultAvatarAdmin(companyAlias) {
    return axios
      .delete(`/api/admin/company/${companyAlias}/avatar`)
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  getPublicProjects(companyUuid) {
    return axios
      .get(`/api/admin/partner/${companyUuid}/projects`)
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
};
